<template>
	<div class="top" v-if="detailPageData.status !== 3 && detailPageData.status !== 4">
		<div v-if="showLeaveBedAvatar">
			<img class="alarm-icon" src="./../../../assets/img/Avatar@2x.png" alt="" />
		</div>
		<div v-else>
			<div v-if="detailPageData.statusName == '睡觉'">
				<img class="alarm-icon" src="./../../../assets/img/AvatarSleep@2x.png" alt="" />
			</div>
			<div v-else>
				<img class="alarm-icon" v-if="stableNum >= 80" src="./../../../assets/img/Avatar_people@2x.png" alt="" />
				<img class="alarm-icon" v-if="stableNum < 80 && stableNum >= 59" src="./../../../assets/img/MediumMove-80.gif"
					alt="" />
				<img class="alarm-icon" v-if="stableNum < 59" src="./../../../assets/img/FastMove-80.gif" alt="" />
			</div>
		</div>
		<div class="status">
			<div class="status-top">
				<div class="text" :class="{ 'text-alarm': isAlarmStatusName }">
					{{ detailPageData.statusName }}
				</div>
				<div class="bar" v-if="monitorStatusStr == ''">
					数据载入中 {{ num }}s
				</div>
				<div class="bar" v-else>{{ monitorStatusStr }}</div>
			</div>
			<div class="stable" v-if="showStableBar">
				<div class="stable-alarm" :style="{
					width: stableNum < 20 ? 20 + '%' : stableNum + '%',
					background:
						'linear-gradient(270deg,' +
						endColor +
						' 0%,' +
						beginColor +
						' 100%)',
				}">
					{{ stableNum }}% 稳定
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RoomLeftTopStatus',
	props: {
		detailPageData: {
			type: Object,
			default: () => ({}),
		},
		stableNum: {
			type: [Number, String],
			default: 0,
		},
		beginColor: {
			type: String,
			default: '#DA9D0B',
		},
		endColor: {
			type: String,
			default: '#65E332',
		},
		monitorStatusStr: {
			type: String,
			default: '',
		},
		num: {
			type: Number,
			default: 0,
		},
	},
	computed: {
		showLeaveBedAvatar() {
			return this.detailPageData.subStatus == 1 && (this.detailPageData.status == 1 || this.detailPageData.status == 5 || this.detailPageData.status == 6);
		},
		isAlarmStatusName() {
			const statusName = this.detailPageData.statusName;
			return (
				statusName == '心跳过速' ||
				statusName == '心跳过缓' ||
				statusName == '呼吸过缓' ||
				statusName == '呼吸过速' ||
				(statusName == '疑似生命体征微弱' && this.detailPageData.status != 1) ||
				statusName == '离床过久'
			);
		},
		showStableBar() {
			return this.detailPageData.subStatus !== 1;
		},
	},
};
</script>

<style lang="scss" scoped>
.top {
	width: 100%;
	display: flex;
	align-items: center;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 10;

	.status {
		flex: 1;
		font-size: 12px;
		display: flex;
		flex-direction: column;

		.status-top {
			display: flex;
			height: 28px;
			line-height: 28px;

			.text {
				min-width: 80px;
				margin-right: 8px;
				text-align: center;
				background: linear-gradient(180deg, #ffffff 0%, #eaeaea 100%);
			}

			.text-alarm {
				color: #ff4d4f;
			}

			.bar {
				flex: 1;
				padding-left: 20px;
				background: linear-gradient(180deg, #ffffff 0%, #eaeaea 100%);
			}
		}

		.stable {
			height: 15px;
		}

		.stable-alarm {
			width: 10%;
			height: 15px;
			padding-left: 20px;
		}
	}

	img {
		width: 80px;
		height: 80px;
	}
}
</style>
